import { UserProfile } from './UserProfile';

export interface User {
  activated: string | null;
  created: string;
  id: string;
  lastLogin: string | null;
  lastUpdated: string | null;
  passwordChanged: string | null;
  profile: UserProfile;
  status: string;
  credentials: UserCredential;
}

export interface UserCredential {
  password: {};
  provider: UserCredentialProvider;
}

export interface UserCredentialProvider {
  type: CredentialProvider;
  name: string;
}

export enum CredentialProvider {
  OKTA = 'OKTA',
  AZURE = 'AZURE',
}

export interface CurrentUserContext {
  previousUser: User;
}
